import { ReactNode } from "react";
import { ModalContext } from "./context";
import { useInviteModal } from "../../hooks/useInviteModal";
import { InviteAffiliateModal } from "../../components/InviteAffiliateModal/InviteAffiliateModal";

interface ModalProviderProps {
  children: ReactNode;
}

export function ModalProvider({ children }: ModalProviderProps) {
  const { isOpen, openModal, closeModal } = useInviteModal();

  const handleOpen = () => {
    openModal();
  };

  const handleClose = () => {
    closeModal();
  };

  return (
    <ModalContext.Provider
      value={{ isOpen, openModal: handleOpen, closeModal: handleClose }}
    >
      {children}
      <InviteAffiliateModal isOpen={isOpen} onClose={handleClose} />
    </ModalContext.Provider>
  );
}
